import { type Employee } from "@finway-group/shared/lib/models"
import { type Reducer } from "redux"
import {
    EmployeeActionTypes,
    type EmployeeActions,
    type FetchAllEmployeesAction,
    type NewUserAction,
    type SyncEmployeeAction,
    type UpdateEmployeeAction,
    type UpdateUserAction,
} from "../actions/employee/employeeTypes"

export interface EmployeeState {
    items: Array<Employee>
}

const initialState = {
    items: [],
}

const fetchAllEmployees = (state: EmployeeState, action: FetchAllEmployeesAction): EmployeeState => ({
    ...state,
    items: action.employees,
})

const syncEmployee = (state: EmployeeState, { employee }: SyncEmployeeAction): EmployeeState => ({
    ...state,
    items: state.items.filter((emp) => emp.id === employee.id).length > 0 ? state.items.map((item) => (item.id === employee.id ? employee : item)) : [employee, ...state.items],
})

const newUser = (state: EmployeeState, action: NewUserAction): EmployeeState => ({
    ...state,
    items: [action.employee, ...state.items],
})

const updateUser = (state: EmployeeState, { employee }: UpdateUserAction): EmployeeState => ({
    ...state,
    items: [...state.items.map((item) => (item.id === employee.id ? employee : item))],
})

const updateEmployee = (state: EmployeeState, { employee }: UpdateEmployeeAction): EmployeeState => ({
    ...state,
    items: [...state.items.map((item) => (item.id === employee.id ? employee : item))],
})

export const employeeReducer: Reducer<EmployeeState, EmployeeActions> = (state = initialState, action) => {
    switch (action.type) {
        case EmployeeActionTypes.FETCH_ALL_EMPLOYEES:
            return fetchAllEmployees(state, action)
        case EmployeeActionTypes.SYNC_EMPLOYEE:
            return syncEmployee(state, action)
        case EmployeeActionTypes.NEW_USER:
            return newUser(state, action)
        case EmployeeActionTypes.UPDATE_USER:
            return updateUser(state, action)
        case EmployeeActionTypes.UPDATE_EMPLOYEE:
            return updateEmployee(state, action)
        default:
            return state
    }
}
